export default __webpack_public_path__ + "assets/images/56d788c29d02e2265ab5431c6f6c2df0.svg";